export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20dreamy%20cherry%20blossom%20petals%20floating%20in%20a%20warm%20golden%20sunset%20sky%2C%20abstract%20ethereal%20atmosphere%20with%20gentle%20pink%20and%20coral%20gradients%2C%20delicate%20bokeh%20light%20particles%2C%20artistic%20Japanese%20aesthetic%20illustration%20style%2C%20painterly%20texture%2C%20dreamlike%20quality%2C%20warm%20cream%20and%20soft%20rose%20tones%2C%20minimalist%20elegant%20composition%2C%20high%20detail%20digital%20art&width=1600&height=900&seq=hero-bg-sakura&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background-50/70 via-background-50/40 to-accent-100/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 lg:pt-0">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs md:text-sm font-medium mb-5">
              <div className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></div>
              高清无删减 · 每日更新
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              91樱花 - 海量高清动漫免费追番平台
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-heading mb-5">
              日漫国漫全收录，更新快画质高，追番从未如此简单
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-7 max-w-xl mx-auto lg:mx-0">
              91樱花动漫平台汇集海量日漫、国漫、剧场版等优质动漫资源，支持在线观看与高速下载。每日同步更新最新番剧，高清画质无删减，全集免费追番。无论你是热血少年漫爱好者、治愈日常番粉丝，还是深度剧情党，这里都能满足你对动漫的所有期待。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-stack-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm font-semibold text-foreground-900">20000+</div>
                  <div className="text-xs text-foreground-500">动漫资源覆盖</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-flashlight-line text-primary-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm font-semibold text-foreground-900">每日同步</div>
                  <div className="text-xs text-foreground-500">最快2小时更新</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-hd-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm font-semibold text-foreground-900">1080P+</div>
                  <div className="text-xs text-foreground-500">超清画质体验</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-play-circle-line text-base"></i>
                </div>
                开始追番
              </a>
              <a
                href="#features"
                onClick={(e) => handleNavClick(e, '#features')}
                className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-8 py-3.5 text-sm font-medium text-foreground-700 bg-background-100 hover:bg-background-200 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none pt-6 md:pt-8 lg:pt-20">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-200/30 rounded-3xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden bg-background-100/80 backdrop-blur-sm border border-background-200/50">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20beautiful%20anime-style%20illustration%20featuring%20a%20cherry%20blossom%20tree%20in%20full%20bloom%20with%20soft%20pink%20petals%20drifting%20through%20the%20air%2C%20warm%20golden%20sunset%20light%2C%20dreamy%20atmospheric%20background%20with%20gentle%20gradients%20of%20coral%20and%20cream%2C%20digital%20art%20style%20with%20painterly%20texture%2C%20elegant%20and%20serene%20Japanese%20aesthetic%2C%20soft%20focus%20background%20with%20warm%20light%20rays%2C%20high%20quality%20illustration&width=900&height=1200&seq=hero-visual-sakura&orientation=portrait"
                  alt="91樱花动漫平台 - 高清动漫在线追番"
                  className="w-full h-auto object-cover"
                />
              </div>

              <div className="absolute -bottom-3 -right-3 bg-background-50 rounded-xl px-4 py-2.5 border border-background-200/70 flex items-center gap-2">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-vip-crown-line text-accent-600 text-sm"></i>
                </div>
                <div>
                  <div className="text-xs font-semibold text-foreground-900 whitespace-nowrap">全站免费</div>
                  <div className="text-[10px] text-foreground-500 whitespace-nowrap">无需会员即可追番</div>
                </div>
              </div>

              <div className="absolute -top-2 -left-3 bg-background-50 rounded-xl px-4 py-2.5 border border-background-200/70 flex items-center gap-2">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-download-cloud-line text-primary-600 text-sm"></i>
                </div>
                <div>
                  <div className="text-xs font-semibold text-foreground-900 whitespace-nowrap">高速下载</div>
                  <div className="text-[10px] text-foreground-500 whitespace-nowrap">多线路极速体验</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}